import { useState } from "react";
import { Link, useNavigate } from "react-router-dom";

const quickLinks = [
  { label: "热血", slug: "re-xue", icon: "ri-fire-line" },
  { label: "恋爱", slug: "lian-ai", icon: "ri-heart-3-line" },
  { label: "治愈", slug: "zhi-yu", icon: "ri-sun-line" },
  { label: "科幻", slug: "ke-huan", icon: "ri-rocket-2-line" },
];

export default function Hero() {
  const [keyword, setKeyword] = useState("");
  const navigate = useNavigate();

  const handleSearch = (e: React.FormEvent) => {
    e.preventDefault();
    const kw = keyword.trim();
    navigate(kw ? `/category/all?q=${encodeURIComponent(kw)}` : "/category");
  };

  return (
    <section className="relative flex min-h-[620px] md:min-h-[700px] items-center overflow-hidden pt-24 md:pt-28">
      <img
        src="https://readdy.ai/api/search-image?query=Expansive%20stylized%20anime%20cityscape%20illustration%20at%20twilight%20with%20glowing%20neon%20skyline%2C%20floating%20clouds%20and%20distant%20mountains%2C%20vibrant%20warm%20coral%20orange%20and%20teal%20color%20palette%2C%20dramatic%20cinematic%20sky%2C%20artistic%20digital%20painting%2C%20wide%20panoramic%20composition%2C%20high%20detail%2C%20harmonious%20color%20balance&width=1920&height=1000&seq=anime-hero-bg&orientation=landscape"
        alt="动漫网 - 动漫世界入口"
        title="动漫网 - 动漫世界入口"
        className="absolute inset-0 h-full w-full object-cover"
      />
      <div className="absolute inset-0 bg-gradient-to-b from-black/40 via-black/25 to-black/40"></div>

      <div className="relative z-10 mx-auto w-full max-w-7xl px-4 md:px-6 text-center">
        <span className="inline-flex items-center gap-2 rounded-full border border-white/30 bg-white/10 px-4 py-1.5 text-sm text-white backdrop-blur">
          <i className="ri-sparkling-2-fill text-primary-400"></i>
          动漫网官网首页 · 导航直达入口
        </span>
        <h1 className="mt-6 font-heading text-4xl leading-tight text-white md:text-6xl">
          欢迎来到<span className="text-primary-400">动漫网</span>
        </h1>
        <p className="mx-auto mt-5 max-w-2xl text-base text-white/85 md:text-lg">
          聚合全频道动漫分类与新番资讯，提供动漫网直达链接与网址收藏指引。打开即可快速进入主页，收藏一次随时访问，无需反复搜索。
        </p>

        <form onSubmit={handleSearch} className="mx-auto mt-8 flex max-w-xl items-center overflow-hidden rounded-full bg-white/95 p-1.5 shadow-lg">
          <div className="flex flex-1 items-center pl-4">
            <i className="ri-search-line text-lg text-foreground-400"></i>
            <input
              type="text"
              value={keyword}
              onChange={(e) => setKeyword(e.target.value)}
              placeholder="输入关键词搜索动漫 / 文章"
              className="w-full bg-transparent py-2 pl-3 text-sm text-foreground-800 outline-none placeholder:text-foreground-400"
            />
          </div>
          <button
            type="submit"
            className="whitespace-nowrap rounded-full bg-primary-500 px-6 py-2.5 text-sm font-medium text-background-50 transition hover:bg-primary-600"
          >
            立即搜索
          </button>
        </form>

        <div className="mt-8 flex flex-col items-center justify-center gap-4 sm:flex-row">
          <Link
            to="/category"
            className="inline-flex items-center whitespace-nowrap rounded-full bg-primary-500 px-8 py-3 text-sm font-medium text-background-50 transition hover:bg-primary-600"
          >
            <i className="ri-compass-3-line mr-2"></i> 浏览全部频道
          </Link>
          <Link
            to="/article"
            className="inline-flex items-center whitespace-nowrap rounded-full border border-white/40 bg-white/10 px-8 py-3 text-sm font-medium text-white backdrop-blur transition hover:bg-white/20"
          >
            <i className="ri-article-line mr-2"></i> 查看动漫资讯
          </Link>
        </div>

        <div className="mt-10 flex flex-wrap items-center justify-center gap-3">
          <span className="text-sm text-white/70">热门直达：</span>
          {quickLinks.map((q) => (
            <Link
              key={q.slug}
              to={`/category/${q.slug}`}
              className="inline-flex items-center gap-1.5 whitespace-nowrap rounded-full border border-white/25 bg-white/10 px-4 py-1.5 text-sm text-white backdrop-blur transition hover:bg-primary-500 hover:border-primary-500"
            >
              <i className={`${q.icon} text-xs`}></i>
              {q.label}
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
}